<illustration-page-layout *ngIf="!isSignedIn" title="{{title}}" logoUrl="{{logoUrl}}">
  <img page-illustration *ngIf="illustration" src="{{illustration}}" alt="Sign in illustration"/>
  <div page-content>
  <div class="card py-sm-2 mt-0 mt-sm-n4 mt-lg-0">
      <div class="card-body py-2 py-sm-3">
        <h4 class="card-title">
          {{cardTitle}}
        </h4>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</illustration-page-layout>
